/* eslint-disable indent */
import EntryGrid from 'components/Inputs/EntryGrid';
import TextBox from 'components/Inputs/TextBox';
import React from 'react';
import { Row, Col, Button, FormGroup } from 'reactstrap';
import DatePicker from 'components/Inputs/DatePicker';
import { t } from 'i18next';
import { useDispatch } from 'react-redux';

function BasicInfoForm({
  register,
  errors,
  control,
  editData,
  setValue,
  watch,
  getValues,
  onFetchInvoiceNumber,
  onSelectWaybill,
  // onSelectOrder,
  selectedOrder,
  selectedAddress,
}) {




  const dispatch = useDispatch();


  return (
    <EntryGrid title={`${t('custom_duty_invoice.custom_duty_invoice')} `}>
      <Row className='pt-1 pb-1'>
        <Col md={3} sm={6} xs={12}>
          <FormGroup>
            <label>{t('deposit_invoice.invoice_number')}</label>
            <div className='d-flex'>
              <div style={{ flex: 1 }}>
                <TextBox
                  className='form-control mr-2'
                  type='text'
                  registerProps={register('basicinfo.invoice_no', {
                    required: `${t('deposit_invoice.invoice_number')} ${t('is_required')}`,
                  })}
                  errors={errors?.basicinfo?.waybill_no}
                  disabled={editData}
                />
              </div>
              <Button
                color='success'
                type='button'
                size='sm'
                style={{ maxHeight: 35 }}
                onClick={() => onFetchInvoiceNumber()}
                disabled={editData || selectedOrder}
              >
                <i className='fa fa-plus text-white'></i>
              </Button>
            </div>
          </FormGroup>
        </Col>
        <Col md={3} sm={6} xs={12}>
          <FormGroup>
            <label>ID No</label>
            <TextBox
              className='form-control mr-2'
              type='text'
              registerProps={register('basicinfo.id_no')}
              errors={errors?.basicinfo?.id_no}
            />
          </FormGroup>
        </Col>
        <Col md={3} sm={6} xs={12}>
          <FormGroup>
            <label>License No</label>
            <TextBox
              className='form-control mr-2'
              type='text'
              registerProps={register('basicinfo.license_no')}
              errors={errors?.basicinfo?.license_no}
            />
          </FormGroup>
        </Col>
        <Col md={3} sm={6} xs={12}>
          <FormGroup>
            <label>Waybill Number</label>
            <div className='d-flex'>
              <div style={{ flex: 1 }}>
                <TextBox
                  className='form-control mr-2'
                  type='text'
                  registerProps={register('basicinfo.waybill_number')}
                  errors={errors?.basicinfo?.waybill_number}
                  disabled={true}
                />
              </div>
              <Button
                color='primary'
                type='button'
                size='sm'
                style={{ maxHeight: 35 }}
                onClick={() => onSelectWaybill && onSelectWaybill()}
              >
                <i className='fa fa-search text-white'></i>
              </Button>
            </div>
          </FormGroup>
        </Col>
      </Row>
      <Row className='pt-1 pb-1'>
        <Col md={2} sm={6} xs={12}>
          <FormGroup>
            <label>Currency</label>
            <TextBox
              className='form-control'
              type='text'
              value='MMK'
              disabled
            />
          </FormGroup>
        </Col>
        <Col md={3} sm={6} xs={12}>
          <FormGroup>
            <label>{t('waybill_entry.sale_person')}</label>

            <TextBox
              value={
                selectedAddress
                  ? selectedAddress?.marketing_person?.name
                  : selectedOrder
                    ? selectedOrder?.sale_person?.name
                    : editData?.sale_person?.name
              }
              disabled
            />
          </FormGroup>
        </Col>
        <Col md={3} sm={6} xs={12}>
          <FormGroup>
            <label>{t('deposit_invoice.invoice_date')}</label>
            <DatePicker
              onChange={(date) => {
                setValue('basicinfo.invoice_date', date);
              }}
              initialValue={getValues('basicinfo.invoice_date')}
            />
          </FormGroup>
        </Col>
        <Col md={4} sm={6} xs={12}>
          <FormGroup>
            <label>{t('waybill_entry.destination')}</label>

            <TextBox
              value={
                selectedAddress
                 ?selectedAddress?.branch?.name:""
              }
              disabled
            />
          </FormGroup>
        </Col>
      </Row>
      <Row className='pt-1 pb-1'>
        <Col md={12}>
          <FormGroup>
            <label>Remarks</label>
            <TextBox
              className='form-control'
              type='text'
              registerProps={register('basicinfo.remark')}
              errors={errors?.basicinfo?.remark}
              placeholder='Enter any additional remarks here'
            />
          </FormGroup>
        </Col>
      </Row>
    </EntryGrid>
  );
}
export default BasicInfoForm;
